import { STORAGE_NAME } from "./featureToggleActions";

export default {
  availableFeatures(state) {
    const features = state.features || localStorage.getItem(STORAGE_NAME) || "";
    if (Array.isArray(features)) {
      return features;
    }
    return features.split(",");
  }
};
